import React from 'react';
import {Link} from 'react-router-dom';

import {SectionTitle} from 'component/reuse/title';
import EarlyAccessForm from '../reuse/form/early_access';


export default class EarlyAccessCTA extends React.Component {
  render (){
    const text_colour = this.props.text_colour || 'primary';
    return (
      <section id="early_access" className="content-section flex-center ">
        <div className="container-fluid my-5">
          <SectionTitle first="Explore stocks and build custom portfolios" second="" background={text_colour} />

          <div className=" text-center">
            <div className=" my-3">
              <EarlyAccessForm />
            </div>
            <div className=" my-3">
              <Link to={"/survey"} className="">Fill out a 1 minute survey</Link>
              <p className="text-muted small">Increases your chances on getting invited early</p>
            </div>
          </div>

        </div>
      </section>
    )
  }
}